export default __webpack_public_path__ + "static/media/CNo.78-3.af39b1ad.jpg";